 
import React, { useEffect } from 'react';
import Debugger from "@debugger";
const logger = Debugger('toolbox');

/** @jsx jsx */
import { jsx, css, useTheme, keyframes } from '@emotion/react';
// import { lighten } from "polished";
const getDebugNamespace = () => {
    try {
        return window.localStorage.debug || '';
    }
    catch (error) {
        logger.log('localStorage unavailable', error);
        return '';
    }
};

const setDebugNamespace = namespace => {
    try {
        window.localStorage.debug = namespace;
    }
    catch (error) {
        logger.log('localStorage unavailable', error);
    }
};

const ToolBox = () => {
    const [namespace, setNamespace] = React.useState(getDebugNamespace);
    const [show, setShow] = React.useState(false);
    useEffect(() => {

        function captureKey(event) {
            // CTRL + Alt + D combo
            if (event.key === '∂') {
                logger.log('captureKey');
                event.preventDefault();
                event.stopPropagation();
                setShow(!show);
            }
        }

        document.addEventListener('keydown', captureKey);
        return () => {
            document.removeEventListener('keydown', captureKey);
        };
    }, [show]);

    const theme = useTheme();

    const animateright = keyframes`
        from {
            right: -300px;
            opacity: 0;
        }
        to {
            right: 0;
            opacity: 1;
        }
    `;
    const styles = css`
        position: fixed;
        top: 10%;
        right: 5%;
        z-index: 100;
        font-family: "Font Awesome 5 Free";
        .gear-button {
            .gear-icon:before {
               content: '\\f085';
               color: ${theme.colors.dark};
            }
        }

        .dev-tools-sidebar {
            top: 7%;
            right: 5%;
            height: 100%;
            width: 400px;
            padding: 0 1em;
            background-color: ${theme.colors.dark};
            color: ${theme.colors.light};
            position: fixed !important;
            z-index: 1;
            overflow: auto;
        }

        .dev-tools-animate-right {
            position: relative;
            animation: ${animateright} 0.4s;
        }

        .dev-tools-card {
            box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16),
            0 2px 10px 0 rgba(0, 0, 0, 0.12);
        }

        .dev-tools-bar-block .dev-tools-bar-item {
            width: 100%;
            display: block;
            padding: 8px 16px;
            text-align: left;
            border: none;
            white-space: normal;
            float: none;
            outline: 0;
        }

        .dev-tools-button {
            user-select: none;
            border: none;
            display: inline-block;
            padding: 8px 16px;
            vertical-align: middle;
            overflow: hidden;
            text-decoration: none;
            color: inherit;
            background-color: inherit;
            text-align: center;
            cursor: pointer;
            white-space: nowrap;
            &:hover {
                color: ${theme.colors.dark};
                background-color: ${theme.colors.light} !important;
            }
        }
    `;
    // style="width:200px;right:0;"

    const openRightMenu = () => {
        document.getElementById("rightMenu").style.display = "block";
    };

    const closeRightMenu = () => {
        document.getElementById("rightMenu").style.display = "none";
    };

    const setDebugNameSpace = () => {
        setDebugNamespace(namespace);
    };
    return (
        // eslint-disable-next-line react/no-unknown-property
        <div css={styles}>
            {show && <button className={'gear-button btn btn-warning'} onClick={openRightMenu}> <span className={'gear-icon'} /> </button>}
            <div className="dev-tools-sidebar dev-tools-bar-block dev-tools-card dev-tools-animate-right" style={{ display: 'none', right: 0 }}
                id="rightMenu">
                <button onClick={closeRightMenu} className="dev-tools-bar-item dev-tools-button">Close &times;</button>
                {/* <a href="#" className="dev-tools-bar-item dev-tools-button">Links 1</a> */}
                {/* <a href="#" className="dev-tools-bar-item dev-tools-button">Link 2</a> */}

                <div className="dev-tools-bar-item ">
                    <label htmlFor="namespace">Debug Namespace</label>
                    <input type="text" name={'namespace'} value={namespace} className={'form-control'} onChange={(e) => setNamespace(e.target.value)} />
                    <button className={'btn btn-primary'} onClick={setDebugNameSpace}>Set</button>
                </div>
            </div>
        </div>
    );
};

export default ToolBox;
